<template>
    <div class="experience">
        <div class="exp-title">
            <h1>Experience</h1>
        </div>
        <div class="exp">
            <div class="outer">
                <div class="card">
                    <div class="info">
                        <p class="title"><strong>Software Associate Engineer</strong> | February 3, 2025 - Present</p>
                        <span class="school">-<strong>MinebeaMitsumi Cebu</strong></span>
                        <ul style="padding-left: 30px;">
                            <li>Design, develop and maintain software applications and features according to customer specifications.</li>
                            <li>Perform code reviews to ensure quality and adherence to coding guidelines</li>
                            <li>Debug and troubleshoot software issues and implement effective solutions</li>
                            <li>Develop software verification plans and quality assurance procedures to ensure system conforms to specified functional requirements</li>
                            <li>Provide technical support to business system and applications used in the production and offices</li>
                            <li>Used: <strong>ASP.NET</strong>, <strong>C#</strong>, <strong>Python</strong>, <strong>Java</strong>, <strong>SQL</strong>.</li>
                        </ul>
                    </div>
                </div>
                <div class="card">
                    <div class="info">
                        <p class="title"><strong>Back-End Web Developer</strong> | June 16, 2023 - January 15, 2025</p>
                        <span class="school">-<strong>Glophics Web Design & Advertising INC.</strong></span>
                        <ul style="padding-left: 30px;">
                            <li>Develop, bug fixing, improving application performance, and maintain web projects.</li>
                            <li>Developing user-facing applications using Vue.js / nuxt js.</li>
                            <li>Outline and communicate in detail any bugs or errors encountered in development.</li>
                            <li>Used: <strong>HTML</strong>, <strong>CSS</strong>, <strong>Saas</strong>, <strong>JavaScript</strong>, <strong>Vue JS</strong>, <strong>Nuxt JS</strong>, <strong>PHP</strong>, <strong>Laravel</strong>, <strong>MySQL</strong>, <strong>AWS</strong>.</li>
                        </ul>
                    </div>
                </div>
                <div class="card">
                    <div class="info">
                        <p class="title"><strong>Web Developer Internship</strong> | February 2023 - June 2023</p>
                        <span class="school">-<strong>Cebu Technological University - Danao Campus</strong></span>
                        <ul style="padding-left: 30px;">
                            <li>Created an <strong>Schedule Plotter with TimeTable</strong> using <strong>HTML</strong>, <strong>CSS</strong>, <strong>Bootstrap</strong>, <strong>JavaScript</strong>, <strong>jQuery</strong>, <strong>PHP</strong>, and <strong>MySQL</strong>, which improved the visibility of viewing all the schedule of sections, teachers, and rooms.</li>
                            <li>Developed an <strong>Online Item Requisition and Management System</strong> using <strong>HTML</strong>, <strong>CSS</strong>, <strong>Bootstrap</strong>, <strong>JavaScript</strong>, <strong>jQuery</strong>, <strong>Flask</strong>, <strong>MSSQL</strong> that allows user to borrow items online and manage new stocks and items. </li>
                            <li>Configure some network and re-routing for computer laboratories and maintainance.</li>
                            <li>Used: <strong>HTML</strong>, <strong>CSS</strong>, <strong>Bootstrap</strong>, <strong>JavaScript</strong>, <strong>jQuery</strong>, <strong>PHP</strong>, <strong>FLASK</strong>, <strong>MySQL</strong>, <strong>MSSQL</strong>.</li>
                        </ul>
                    </div>
                </div>
                <div class="card">
                    <div class="info">
                        <p class="title"><strong>Web Developer Freelance</strong> | September 2022 - January 2023</p>
                        <ul style="padding-left: 30px;">
                            <li>Co-Created a <strong>Web Based Preventive Maintenance System</strong> that allows user to track their date of machines maintenance with before and after images of maintenance.</li>
                            <li>Used: <strong>HTML</strong>, <strong>CSS</strong>, <strong>Bootstrap</strong>, <strong>JavaScript</strong>, <strong>jQuery</strong>, <strong>PHP</strong>, <strong>MySQL</strong>, <strong>AWS(Ec2)</strong>.</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="cert">
            <div class="cert-title">
                <h1>Certifications</h1>
            </div>
        </div> -->
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>
